import React from "react";

const DeleteSVG = ({ fillColor, disabled }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 26 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
    >
      <path
        d="M5.08325 27.5C4.21242 27.5 3.46693 27.2063 2.84679 26.6188C2.22665 26.0312 1.91659 25.325 1.91659 24.5V5H0.333252V2H8.24992V0.5H17.7499V2H25.6666V5H24.0833V24.5C24.0833 25.325 23.7732 26.0312 23.153 26.6188C22.5329 27.2063 21.7874 27.5 20.9166 27.5H5.08325ZM20.9166 5H5.08325V24.5H20.9166V5ZM8.24992 21.5H11.4166V8H8.24992V21.5ZM14.5833 21.5H17.7499V8H14.5833V21.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default DeleteSVG;
